import Boot from "@/main";
import { SessionActions } from "@/store/sessionStore";
import Bus from "@/utils/events/bus";

const nfetch = function (url, options) {
    const token = localStorage.getItem("@PharmUP:Token");
    const webSocketId = sessionStorage.getItem("@PharmUP:WebSocketId");

    return fetch(`${process.env.VUE_APP_ROOT_API}${url}`, {
        ...options,
        headers: {
            Authorization: `Bearer ${token}`,
            "web-socket-id": webSocketId,
            ...options.headers,
        },
    }).then(response => {
        Bus.$emit("nfetch-service-event", response);

        if (response.status == 401) {
            if (localStorage.getItem("@PharmUP:Token")) {
                document.location.reload();
            }
            Boot.$store.dispatch(SessionActions.LOGOUT);
        }

        return response;
    });
};

// Uso pontual: só para requisições que não podem deixar o loading preso indefinidamente (ex: emissão de NF-e).
export const nfetchWithTimeout = function (url, options, timeoutMs: number) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

    return nfetch(url, { ...options, signal: controller.signal })
        .then(response => {
            clearTimeout(timeoutId);
            return response;
        })
        .catch(err => {
            clearTimeout(timeoutId);
            if (err.name == "AbortError") {
                throw new Error("A requisição demorou demais para responder. Verifique sua conexão e tente novamente.");
            }
            throw err;
        });
};

export default nfetch;
